module.exports = __webpack_public_path__ + "static/media/bottom.9847456d.png";